import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';

const ThisPeriodMaintenanceLicencesCard = ({ loading, count }) => {
  const tooltip = (
    <Tooltip id="maintenance-licences-tooltip">
      <div className="small">
        選択期間中に<strong>有効期限または保守期限</strong>の変更があったライセンス数です。<br />
        同一ライセンスに対する複数回の変更は<strong>1件として集計</strong>しています。
      </div>
    </Tooltip>
  );

  return (
    <Card className="mb-2">
      <Card.Body>
        <Card.Title className="fs-6 d-flex align-items-center">
          <span>有効／保守期限変更ライセンス数（選択期間）</span>

          <OverlayTrigger
            placement="top"
            overlay={tooltip}
            trigger={['hover', 'focus', 'click']} // PC: hover/focus, スマホ: tap(click)
          >
            <span
              className="ms-2 text-muted"
              style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
              aria-label="説明"
            >
              <InfoCircle size={16} />
            </span>
          </OverlayTrigger>
        </Card.Title>

        <div className="fs-2 fw-bold">
          {loading ? '...' : count}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ThisPeriodMaintenanceLicencesCard;
